import { action, makeAutoObservable, runInAction } from 'mobx'
import { SignedInUser } from '../../api/DTO'
import UserClient from '../../api/clients/identity/UserClient'
import SessionData from './SessionData'

type UserStatus =
	| {
			readonly status: 'anonymous'
	  }
	| {
			readonly status: 'fetching'
			promise: Promise<SignedInUser>
	  }
	| {
			readonly status: 'retrieved'
			userInfo: SignedInUser
			readonly jti: string
	  }

class SignedInUserService {
	private _userStatus: UserStatus = { status: 'anonymous' }

	public get user(): UserStatus {
		this.getSignedInUser()

		return this._userStatus
	}

	constructor() {
		makeAutoObservable(this)
	}

	private getSignedInUser = () => {
		if (this._userStatus.status === 'fetching') return this._userStatus

		const accessToken = SessionData.accessToken
		console.log('value of access token: ', accessToken)

		if (!accessToken) {
			if (this._userStatus.status !== 'anonymous')
				this._userStatus = { status: 'anonymous' }
			return this._userStatus
		}

		const tokenPayload = accessToken.tokenPayload
		console.log('token payload: ', tokenPayload)
		console.log('is anonymous?: ', tokenPayload?.anonymous)

		if (!tokenPayload || tokenPayload.anonymous === true) {
			if (this._userStatus.status !== 'anonymous')
				this._userStatus = { status: 'anonymous' }
			return this._userStatus
		}

		const fetchToken = () => {
			const client = new UserClient()

			const promise = client.MyInfo().then(
				action((v) => {
					console.log('😎 got my info')
					this._userStatus = {
						status: 'retrieved',
						jti: tokenPayload.jti,
						userInfo: v.data,
					}

					return v.data
				}),
			)

			runInAction(() => {
				this._userStatus = {
					status: 'fetching',
					promise: promise,
				}
			})
		}

		if (this._userStatus.status === 'anonymous' && tokenPayload) {
			if (tokenPayload.anonymous && this._userStatus.status === 'anonymous') {
				return
			} else if (
				!tokenPayload.anonymous &&
				this._userStatus.status === 'anonymous'
			) {
				console.log('fetching token')
				fetchToken()
			} else {
				this._userStatus = { status: 'anonymous' }
			}
		}

		if (
			this._userStatus.status === 'retrieved' &&
			this._userStatus.jti !== tokenPayload.jti
		) {
			fetchToken()
		}
	}
}

const signedInUserService = new SignedInUserService()

export default signedInUserService
